import _ from 'lodash'
export default function TourSortingFilter(tours, sorting) {
    if(!sorting || !sorting.key || !sorting.order) return tours
    return _.orderBy(tours, sorting.key, sorting.order)
}